import { MagnifyingGlassIcon } from '@heroicons/react/20/solid';
import React, { useState, useEffect } from 'react';
import SearchModal from '../molecules/SearchModal';
import { useGetAppsQuery } from '../../apiHooks/appsApi';
import { BioLibGlobalEvent } from '../../globalEvents';

export default function NavbarSearchBar() {
    const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);

    const { data: prefetchedAppsData } = useGetAppsQuery({
        page: 1,
        page_size: 100,
        resource_type: 'app',
    });

    const handleClick = () => {
        setIsSearchModalOpen(true);
    };

    const isMac = typeof navigator !== 'undefined' && /Mac/i.test(navigator.platform);
    const shortcutKey = isMac ? '⌘' : 'ctrl';

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.repeat) {
                return;
            }

            if ((event.metaKey || event.ctrlKey) && event.key === 'k') {
                event.preventDefault();
                setIsSearchModalOpen((prev) => !prev);
            }
        };

        const handleOpenSearchFromIframe = () => {
            setIsSearchModalOpen((prev) => !prev);
        };

        window.addEventListener('keydown', handleKeyDown);
        window.addEventListener(BioLibGlobalEvent.openSearch, handleOpenSearchFromIframe);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            window.removeEventListener(BioLibGlobalEvent.openSearch, handleOpenSearchFromIframe);
        };
    }, []);

    return (
        <>
            <div className='grid'>
                <button
                    type='button'
                    onClick={handleClick}
                    aria-label='Search BioLib'
                    title='Click to search for applications and results on BioLib'
                    className='col-start-1 row-start-1 flex items-center justify-between w-full rounded-md bg-white/15 py-1.5 pl-10 pr-3 text-sm font-medium text-white border border-white/30 outline-none cursor-pointer'
                >
                    <span>Search BioLib</span>
                    <div className='flex items-center gap-0.5 text-sm'>
                        <span className='text-white/60'>{shortcutKey}</span>
                        <span>K</span>
                    </div>
                </button>
                <MagnifyingGlassIcon
                    aria-hidden='true'
                    className='pointer-events-none col-start-1 row-start-1 ml-3 size-5 self-center text-white'
                />
            </div>
            <SearchModal
                open={isSearchModalOpen}
                onClose={() => setIsSearchModalOpen(false)}
                prefetchedApps={prefetchedAppsData?.results ?? []}
            />
        </>
    );
}
